import AreaTemplate from '../AreaTemplate';

const schema = {
  '@context': 'https://schema.org',
  '@type': 'ElectricalContractor',
  name: 'Electrician Solutions Fresno — Selma',
  description: 'Licensed electrician serving Selma, CA. C-10 certified electrical contractor for residential and commercial electrical work in Selma and the Fresno South region.',
  address: {
    '@type': 'PostalAddress',
    addressLocality: 'Selma',
    addressRegion: 'CA',
    postalCode: '93662',
    addressCountry: 'US',
  },
  geo: { '@type': 'GeoCoordinates', latitude: '36.5705', longitude: '-119.6121' },
  url: 'https://electriciansolutionsfresno.com/areas/selma',
  telephone: '+1-559-123-4567',
  priceRange: '$$',
  areaServed: { '@type': 'City', name: 'Selma', '@id': 'https://en.wikipedia.org/wiki/Selma,_California' },
};

const faqs = [
  {
    q: 'Do you provide electrician services in Selma, CA?',
    a: 'Yes! Electrician Solutions Fresno serves all of Selma, CA — the "Raisin Capital of the World." Our C-10 licensed electricians handle residential, commercial, and agricultural electrical work throughout Selma and the surrounding Fresno south corridor.',
  },
  {
    q: 'What electrical services do you offer in Selma?',
    a: 'We provide full electrical services in Selma including panel upgrades, whole-house rewiring, EV charger installation, kitchen and bathroom electrical, new circuit additions, smart home systems, fire alarm installation, and 24/7 emergency electrical repairs.',
  },
  {
    q: 'How quickly can you reach Selma for emergencies?',
    a: 'Selma is approximately 15 miles south of Fresno via Highway 99, so our emergency response time is typically 30–50 minutes. We have licensed electricians on call 24/7 for urgent electrical issues in Selma.',
  },
  {
    q: 'Do you handle grape vineyard and packing shed electrical work near Selma?',
    a: 'Yes. The Selma area is surrounded by raisin vineyards and packing operations. We install and service electrical systems for packing sheds, cold storage facilities, irrigation pump stations, and agricultural operations throughout the Selma region.',
  },
  {
    q: 'Do Selma projects require City permits?',
    a: 'Yes. The City of Selma Building Department requires electrical permits for panel upgrades, rewiring, and new circuits. We handle all permit applications and coordinate final inspections as part of every project in Selma.',
  },
  {
    q: 'Can you install solar panels and battery systems in Selma?',
    a: 'We handle the electrical side of solar installations in Selma — panel upgrades, interconnection wiring, battery storage installation, and solar-ready sub-panels. With Selma\'s 280+ sunny days, solar is a great investment for local homeowners.',
  },
];

const SelmaPage = () => (
  <AreaTemplate
    area="Selma"
    areaSlug="selma"
    state="CA"
    county="Fresno County"
    population="25,000+"
    description="Electrician Solutions Fresno proudly serves Selma, CA — the Raisin Capital of the World. Just 15 miles south of Fresno on Highway 99, Selma is a thriving community with unique residential and agricultural electrical needs. Our C-10 licensed electricians understand the unique demands of Selma's homes, businesses, and surrounding vineyard operations, delivering expert electrical services at competitive prices."
    neighborhoods={['Downtown Selma', 'North Selma', 'East Selma', 'Whitson Ave Area', 'Highland Ave Corridor', 'Cherry Ave', 'Selma Ranch Estates', 'South Selma']}
    nearbyAreas={[
      { name: 'Fresno', slug: 'fresno' },
      { name: 'Clovis', slug: 'clovis' },
      { name: 'Sanger', slug: 'sanger' },
      { name: 'Fowler', slug: 'fowler' },
      { name: 'Reedley', slug: 'reedley' },
    ]}
    faqs={faqs}
    heroImage="https://public.readdy.ai/ai/img_res/4a757a868dc673652ebc82c406f9904b.jpg"
    heroImageAlt="Licensed Electrician in Selma CA"
    teamImage="https://readdy.ai/api/search-image?query=Professional%20electrician%20team%20in%20uniforms%20standing%20in%20front%20of%20Selma%20California%20raisin%20vineyards%20and%20agricultural%20landscape%20with%20rows%20of%20grapevines%20blue%20sky%20showing%20local%20expertise%20and%20Central%20Valley%20farming%20community%20connection&width=800&height=600&seq=selma_team_001&orientation=landscape"
    teamImageAlt="Electrician Solutions team serving Selma CA"
    schema={schema}
  />
);

export default SelmaPage;
